import script from "./StepProcess.vue?vue&type=script&lang=ts&setup=true"
export * from "./StepProcess.vue?vue&type=script&lang=ts&setup=true"

import "./StepProcess.vue?vue&type=style&index=0&id=4f5297e5&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f5297e5"]])

export default __exports__